import React from 'react';
import { IIcon } from './icon';
import { SvgIcon } from './svgs';

const Icon = ({ type, className, viewBox = '0 0 26 26', title='' }: IIcon) => {

	return (
		<>
		{title && <span id={`${title.replace(/\s/g, '')}-icon`} className="sr-only">{`${title}-icon`}</span>}
		<svg
			fill="currentColor"
			className={className || ''}
			viewBox={viewBox}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			aria-labelledby={title? `${title?.replace(/\s/g, '')}-icon` : ''}>
			<SvgIcon svgName={type as string} />
		</svg>
		</>
	);
};

export default Icon;
